/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

import PitchMotorBrakeGap from "src/views/report/custom/PitchMotorBrakeGap.react";
import Grease from "src/views/report/custom/Grease.react";
import PrintHeader from "src/components/print/PrintHeader.react";

/**
 * The Hub component
 *
 * @author Thais Watanabe
 */
const Hub = (props) => {
  const {
    turbineInspection,
    inspectionModelItems,
    inspectionModel,
    results,
    lastResults,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  const lastOneYear = lastTurbineInspections.find((obj) =>
    obj.inspection.type.startsWith("1年")
  );

  // 8-5
  const i8_5 = inspectionModelItems.filter((obj) => obj.name === "8-5")?.[0];
  const r8_5 = results.filter((obj) => obj.itemId === "8-5")?.[0];
  const last_r8_5 = lastResults?.filter(
    (obj) => obj.itemId === "8-5" && obj.turbineInspectionID === lastOneYear
  )?.[0];

  // 8-7
  const i8_7 = inspectionModelItems.filter((obj) => obj.name === "8-7")?.[0];
  const r8_7 = results.filter((obj) => obj.itemId === "8-7")?.[0];

  // 8-8
  const i8_8 = inspectionModelItems.filter((obj) => obj.name === "8-8")?.[0];
  const r8_8 = results.filter((obj) => obj.itemId === "8-8")?.[0];

  // 8-9
  const i8_9 = inspectionModelItems.filter((obj) => obj.name === "8-9")?.[0];
  const r8_9 = results.filter((obj) => obj.itemId === "8-9")?.[0];

  // Last inspection
  const last_r8_7 = lastResults?.filter((obj) => obj.itemId === "8-7");
  const last_r8_8 = lastResults?.filter((obj) => obj.itemId === "8-8");
  const last_r8_9 = lastResults?.filter((obj) => obj.itemId === "8-9");

  // 8-10
  const i8_10 = inspectionModelItems.filter((obj) => obj.name === "8-10")?.[0];
  const r8_10 = results.filter((obj) => obj.itemId === "8-10")?.[0];
  const last_r8_10_1 = lastResults?.filter((obj) => obj.itemId === "8-10")?.[0];
  const last_r8_10_2 = lastResults?.filter((obj) => obj.itemId === "8-10")?.[1];

  // 8-14
  const i8_14 = inspectionModelItems.filter((obj) => obj.name === "8-14")?.[0];
  const r8_14 = results.filter((obj) => obj.itemId === "8-14")?.[0];
  const last_r8_14_1 = lastResults?.filter((obj) => obj.itemId === "8-14")?.[0];
  const last_r8_14_2 = lastResults?.filter((obj) => obj.itemId === "8-14")?.[1];

  // 8-15
  const i8_15 = inspectionModelItems.filter((obj) => obj.name === "8-15")?.[0];
  const r8_15 = results.filter((obj) => obj.itemId === "8-15")?.[0];
  const last_r8_15_1 = lastResults?.filter((obj) => obj.itemId === "8-15")?.[0];
  const last_r8_15_2 = lastResults?.filter((obj) => obj.itemId === "8-15")?.[1];

  // 8-17
  const i8_17 = inspectionModelItems.filter((obj) => obj.name === "8-17")?.[0];
  const r8_17 = results.filter((obj) => obj.itemId === "8-17")?.[0];

  // 8-18
  const i8_18 = inspectionModelItems.filter((obj) => obj.name === "8-18")?.[0];
  const r8_18 = results.filter((obj) => obj.itemId === "8-18")?.[0];
  const last_r8_18_1 = lastResults?.filter((obj) => obj.itemId === "8-18")?.[0];
  const last_r8_18_2 = lastResults?.filter((obj) => obj.itemId === "8-18")?.[1];

  return (
    <>
      <Card className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center" colSpan={19}>
                ブレーキパッド測定結果表
              </ColHeader>
            </tr>
            <tr>
              <ColHeader
                id="8-5"
                className="w-10 text-center print:hidden"
                rowSpan={2}
              >
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i8_5}
                  selectedResult={r8_5}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center" colSpan={6}>
                今回
              </ColHeader>
              <ColHeader className="text-center" colSpan={5}>
                {lastOneYear?.inspection?.name ?? "過去"}
              </ColHeader>
            </tr>
            <tr>
              <ColHeader className="w-10 text-center">No.</ColHeader>
              <ColHeader className="text-center">①</ColHeader>
              <ColHeader className="text-center">②</ColHeader>
              <ColHeader className="text-center">③</ColHeader>
              <ColHeader className="text-center">④</ColHeader>
              <ColHeader className="text-center">⑤</ColHeader>
              <ColHeader className="text-center">①</ColHeader>
              <ColHeader className="text-center">②</ColHeader>
              <ColHeader className="text-center">③</ColHeader>
              <ColHeader className="text-center">④</ColHeader>
              <ColHeader className="text-center">⑤</ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">1</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[0] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[0].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[0] ?? "-", 0)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[1] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[1].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[1] ?? "-", 1)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[2] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[2].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[2] ?? "-", 2)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[3] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[3].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[3] ?? "-", 3)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[4] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[4].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[4] ?? "-", 4)}
                />
              </Col>
              {/*  */}
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[0] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[0] ?? "-",
                    0
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[1] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[1].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[1] ?? "-",
                    1
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[2] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[2].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[2] ?? "-",
                    2
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[3] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[3].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[3] ?? "-",
                    3
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[4] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[4].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[4] ?? "-",
                    4
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">2</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[5] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[5].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[5] ?? "-", 5)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[6] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[6].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[6] ?? "-", 6)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[7] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[7].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[7] ?? "-", 7)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[8] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[8].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[8] ?? "-", 8)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[9] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[9].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[9] ?? "-", 9)}
                />
              </Col>
              {/*  */}
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[5] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[5].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[5] ?? "-",
                    5
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[6] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[6].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[6] ?? "-",
                    6
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[7] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[7].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[7] ?? "-",
                    7
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[8] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[8].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[8] ?? "-",
                    8
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[9] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[9].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[9] ?? "-",
                    9
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">3</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[10] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[10].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[10] ?? "-", 10)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[11] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[11].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[11] ?? "-", 11)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[12] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[12].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[12] ?? "-", 12)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[13] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[13].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[13] ?? "-", 13)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[14] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[14].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[14] ?? "-", 14)}
                />
              </Col>
              {/*  */}
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[10] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[10].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[10] ?? "-",
                    10
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[11] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[11].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[11] ?? "-",
                    11
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[12] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[12].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[12] ?? "-",
                    12
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[13] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[13].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[13] ?? "-",
                    13
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[14] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[14].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[14] ?? "-",
                    0
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">4</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[15] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[15].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[15] ?? "-", 15)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[16] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[16].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[16] ?? "-", 16)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[17] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[17].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[17] ?? "-", 17)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[18] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[18].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[18] ?? "-", 18)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[19] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[19].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[19] ?? "-", 19)}
                />
              </Col>
              {/*  */}
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[15] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[15].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[15] ?? "-",
                    15
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[16] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[16].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[16] ?? "-",
                    16
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[17] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[17].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[17] ?? "-",
                    17
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[18] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[18].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[18] ?? "-",
                    18
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[19] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[19].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[19] ?? "-",
                    19
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">5</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[20] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[20].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[20] ?? "-", 20)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[21] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[21].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[21] ?? "-", 21)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[22] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[22].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[22] ?? "-", 22)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[23] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[23].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[23] ?? "-", 23)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_5?.childrenResults[24] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[24].unit}
                  isInputCorrect={isInputCorrect("8-5", r8_5?.[24] ?? "-", 24)}
                />
              </Col>
              {/*  */}
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[20] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[20].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[20] ?? "-",
                    20
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[21] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[21].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[21] ?? "-",
                    21
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[22] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[22].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[22] ?? "-",
                    22
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[23] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[23].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[23] ?? "-",
                    23
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_5?.childrenResults[24] ?? "-"}
                  unit={i8_5?.inspectionModelItemChildren.items?.[24].unit}
                  isInputCorrect={isInputCorrect(
                    "8-5",
                    last_r8_5?.[24] ?? "-",
                    24
                  )}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>

      <Card className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center" colSpan={19}>
                ピッチモータ絶縁抵抗測定結果表
              </ColHeader>
            </tr>
            <tr>
              <ColHeader id="8-10" className="w-10 text-center print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i8_10}
                  selectedResult={r8_10}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center">軸</ColHeader>
              <ColHeader className="text-center w-80">今回</ColHeader>
              <ColHeader className="text-center">
                {lastTurbineInspections?.[0]?.inspection?.name}
              </ColHeader>
              <ColHeader className="text-center">
                {lastTurbineInspections?.[1]?.inspection?.name}
              </ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">1</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_10?.childrenResults[0] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[0].unit}
                  isInputCorrect={isInputCorrect("8-10", r8_10?.[0] ?? "-", 0)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_1?.childrenResults[0] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_1?.[0] ?? "-",
                    0
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_2?.childrenResults[0] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_2?.[0] ?? "-",
                    0
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">2</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_10?.childrenResults[1] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[1].unit}
                  isInputCorrect={isInputCorrect("8-10", r8_10?.[1] ?? "-", 1)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_1?.childrenResults[1] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[1].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_1?.[1] ?? "-",
                    1
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_2?.childrenResults[1] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[1].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_2?.[1] ?? "-",
                    1
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">3</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_10?.childrenResults[2] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[2].unit}
                  isInputCorrect={isInputCorrect("8-10", r8_10?.[2] ?? "-", 2)}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_1?.childrenResults[2] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[2].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_1?.[2] ?? "-",
                    2
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_10_2?.childrenResults[2] ?? "-"}
                  unit={i8_10?.inspectionModelItemChildren.items?.[2].unit}
                  isInputCorrect={isInputCorrect(
                    "8-10",
                    last_r8_10_2?.[2] ?? "-",
                    2
                  )}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>

      <Card className="print:mt-2 pagebreak">
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <PitchMotorBrakeGap
          inspection={inspection}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          i8_7={i8_7}
          r8_7={r8_7}
          i8_8={i8_8}
          r8_8={r8_8}
          i8_9={i8_9}
          r8_9={r8_9}
          isPastInspection={false}
          openEdit={openEdit}
          openObs={openObs}
        />
      </Card>

      <Card className="pagebreak">
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <PitchMotorBrakeGap
          inspection={inspection}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          i8_7={i8_7}
          r8_7={last_r8_7?.[0]}
          i8_8={i8_8}
          r8_8={last_r8_8?.[0]}
          i8_9={i8_9}
          r8_9={last_r8_9?.[0]}
          lastInspection={lastTurbineInspections?.[0]}
          isPastInspection={true}
          openEdit={openEdit}
          openObs={openObs}
        />
      </Card>

      <Card className="pagebreak">
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <PitchMotorBrakeGap
          inspection={inspection}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          i8_7={i8_7}
          r8_7={last_r8_7?.[1]}
          i8_8={i8_8}
          r8_8={last_r8_8?.[1]}
          i8_9={i8_9}
          r8_9={last_r8_9?.[1]}
          lastInspection={lastTurbineInspections?.[1]}
          isPastInspection={true}
          openEdit={openEdit}
          openObs={openObs}
        />
      </Card>

      <div className="pagebreak">
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <Card className="grid gap-x-4 grid-cols-2">
          <Grease
            inspection={inspection}
            turbineInspection={turbineInspection}
            lastTurbineInspections={lastTurbineInspections}
            title={"ブレードベアリング自動潤滑装置　グリース記録表"}
            inspectionModel={i8_14}
            result={r8_14}
            lastResult1={last_r8_14_1}
            lastResult2={last_r8_14_2}
            openEdit={openEdit}
            openObs={openObs}
          />

          <Grease
            inspection={inspection}
            turbineInspection={turbineInspection}
            lastTurbineInspections={lastTurbineInspections}
            title={"ピッチギア自動潤滑装置　グリース記録表"}
            inspectionModel={i8_15}
            result={r8_15}
            lastResult1={last_r8_15_1}
            lastResult2={last_r8_15_2}
            openEdit={openEdit}
            openObs={openObs}
          />
        </Card>
      </div>

      <Card className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center" colSpan={19}>
                インシュレーションブッシュ取付方向確認表
              </ColHeader>
            </tr>
            <tr>
              <ColHeader id="8-17" className="w-10 text-center print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i8_17}
                  selectedResult={r8_17}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center">箇所</ColHeader>
              <ColHeader className="text-center">1軸</ColHeader>
              <ColHeader className="text-center">2軸</ColHeader>
              <ColHeader className="text-center">3軸</ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">
                タイプ
                <br />
                (A､B､C)
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_17?.childrenResults[0] ?? "-"}
                  isInputCorrect={true}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_17?.childrenResults[1] ?? "-"}
                  isInputCorrect={true}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_17?.childrenResults[2] ?? "-"}
                  isInputCorrect={true}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>

      <Card className="print:mt-2">
        <Table>
          <thead>
            <tr>
              <ColHeader className="text-center" colSpan={19}>
                リミットスイッチ動作確認結果表
              </ColHeader>
            </tr>
            <tr>
              <ColHeader
                id="8-18"
                className="w-10 text-center print:hidden"
                rowSpan={2}
              >
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i8_18}
                  selectedResult={r8_18}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="text-center" colSpan={3}>
                今回
              </ColHeader>
              <ColHeader className="text-center" colSpan={2}>
                {lastTurbineInspections?.[0]?.inspection.name}
              </ColHeader>
              <ColHeader className="text-center" colSpan={2}>
                {lastTurbineInspections?.[1]?.inspection.name}
              </ColHeader>
            </tr>
            <tr>
              <ColHeader className="text-center">軸</ColHeader>
              <ColHeader className="text-center">0°側</ColHeader>
              <ColHeader className="text-center">90°側</ColHeader>
              <ColHeader className="text-center">0°側</ColHeader>
              <ColHeader className="text-center">90°側</ColHeader>
              <ColHeader className="text-center">0°側</ColHeader>
              <ColHeader className="text-center">90°側</ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">1</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[6] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[6].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[6] ?? "-",
                    6
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[7] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[7].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[7] ?? "-",
                    7
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[6] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[6].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[6] ?? "-",
                    6
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[7] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[7].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[7] ?? "-",
                    7
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[6] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[6].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[6] ?? "-",
                    6
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[7] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[7].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[7] ?? "-",
                    7
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">2</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[8] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[8].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[8] ?? "-",
                    8
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[9] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[9].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[9] ?? "-",
                    9
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[8] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[8].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[8] ?? "-",
                    8
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[9] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[9].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[9] ?? "-",
                    9
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[8] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[8].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[8] ?? "-",
                    8
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[9] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[9].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[9] ?? "-",
                    9
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="text-center print:hidden"></Col>
              <Col className="text-center">3</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[10] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[10].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[10] ?? "-",
                    10
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r8_18?.childrenResults[11] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[11].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    r8_18?.childrenResults[11] ?? "-",
                    11
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[10] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[10].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[10] ?? "-",
                    10
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_1?.childrenResults[11] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[11].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_1?.childrenResults[11] ?? "-",
                    11
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[10] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[10].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[10] ?? "-",
                    10
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r8_18_2?.childrenResults[11] ?? "-"}
                  unit={i8_18?.inspectionModelItemChildren.items?.[11].unit}
                  isInputCorrect={isInputCorrect(
                    "8-18",
                    last_r8_18_2?.childrenResults[11] ?? "-",
                    11
                  )}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>
    </>
  );
};

export default Hub;
